import React, { useState, useEffect } from "react";
import ApiConfig from "../../../api/ApiConfig";
import { simplePostCall } from "../../../api/ApiServices";
import Params from "../../../config/Params";

const AssignmentModal = (props) => {
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [state, setState] = useState({
    title: "",
    description: "",
    subject: "",
    class_division_id: "",
    class_id: "",
    lesson_id: "",
    question_type: "",
    content: "",
    submission_date: "",
    submission_mode: "",
    students: "1",
    curriculum: "ccm22",
    type: "writing",
  });

  function loadClassList() {
    simplePostCall(
      ApiConfig.CLASSES_LIST_API,
      JSON.stringify({ ...Params, user_id: Params.teacher_id })
    )
      .then((data) => {
        if (data.result) {
          setClassList(data.list);
          setState({ ...state, class_id: data.list[0].class_id })
          loadSectionList(data.list[0].class_id);
        }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  }
  function loadSectionList(classId) {
    simplePostCall(
      ApiConfig.SECTION_LIST_API,
      JSON.stringify({
        ...Params,
        user_id: Params.teacher_id,
        class_id: classId,
      })
    )
      .then((data) => {
        if (data.result) {
          let section_id = data.list[0].class_division_id;
          loadSubjectList(section_id);
          getStudents(classId, section_id)
          setSectionList(data.list);
          var onj = { ...state, class_division_id: section_id }

          setState(onj)
        } else {
          setSectionList([]);
          setSubjectList([]);
          setStudentList([]);
        }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  }

  function loadSubjectList(classId) {
    simplePostCall(
      ApiConfig.SUBJECT_LIST_API,
      JSON.stringify({
        ...Params,
        user_id: Params.teacher_id,
        class_id: classId,
      })
    )
      .then((data) => {
        if (data.result) {
          setState({ ...state, subject: data.list[0].id })
          setSubjectList(data.list);
        }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  }


  const getStudents = (classId, section_id) => {
    // setIsloading(true);
    const newRequestBody = {
      api_key: Params.api_key,
      customer_id: Params.customer_id,
      user_id: Params.teacher_id,
      class_id: classId,
      section_id: section_id,
    };
    simplePostCall(ApiConfig.STUDENTS_API, JSON.stringify(newRequestBody))
      .then((data) => {
        // setIsloading(false)
        if (data.result) {
          setStudentList(data.list);
        }
      })
      .catch((error) => {
        // setIsloading(false)
        console.log("api response", error);
      });
  };


  const onInputChangeHandle = (e) => {
    const { name, value } = e.target;

    if (name === "class_id") loadSectionList(value);
    if (name === "class_division_id") { loadSubjectList(value); }
    var obj = { ...state, [name]: value };
    setState(obj);
  };
  const displayStyle = {
    display: "block",
  };
  const onSubmitHandle = () => {
    console.log("state :: ", state)
    state.class_division_id = state.class_division_id ? state.class_division_id : document.getElementsByName("class_division_id")[0].value;
    simplePostCall(
      ApiConfig.ASSIGNMENT_CREATE_API,
      JSON.stringify({
        ...Params,
        ...state,
      })
    )
      .then((data) => {
        if (data.result) {
          props.onClose(true)
        }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  };

  useEffect(() => {
    loadClassList();
  }, []);
  useEffect(() => { }, [subjectList]);

  return (
    <>

      
    </>
  );
};

export default AssignmentModal;
